const VALID_EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const required = () => ({
  name: 'required',
  message: 'cannot be blank'
});

export const minLength = (minChars = 1) => ({
  name: 'minLength',
  minLength: minChars, message: `must be at least ${minChars} characters`
});

export const validEmail = () => ({
  name: 'validEmail',
  message: 'Must be a valid email address'
});

export const validate = (value, validations) => {
  for (const validation of validations) {
    switch (validation.name) {
      case 'required':
        if (!value || value === '') return validation.message;
        break;
      case 'validEmail':
        if (!VALID_EMAIL_REGEX.test(String(value).toLowerCase())) return validation.message;
        break;
      case 'minLength':
        if (!value || value.length < validation.minLength) return validation.message;
        break;
    }
  }
  return null;
};